<ng-container *ngIf="a11yImages === undefined || a11yImages.length === 0; then imageItem; else a11yImageSet"></ng-container>

<ng-template #defaultImg>
  <ng-content></ng-content>
</ng-template>

<ng-template #imageItem>
  <ng-container *ngTemplateOutlet="defaultImg"></ng-container>
</ng-template>
<ng-template #a11yImageSet>
  <picture>
    <source
      *ngFor="let image of a11yImages"
      [type]="image.type"
      [srcset]="image.srcset"
    >
    <!--  Default (last)  -->
    <ng-container *ngTemplateOutlet="defaultImg"></ng-container>
  </picture>
</ng-template>
<h2 class="large-card--title" [innerHTML]="title"></h2>
<p class="large-card--indent" [innerHTML]="description"></p>
